import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { brandNeutralColors } from '@anyroad/theme';

const Style = styled.h2`
  font-size: 28px;
  font-weight: 600;
  line-height: 20px;
  margin: 0 0 24px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${brandNeutralColors.text.primary};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SubText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${brandNeutralColors.text.secondary};
`;

export const PaymentHeader = () => {
  return (
    <HeaderContainer>
      <Style className="CheckoutHeader-Page2" data-testid="payment-step-header">
        <FormattedMessage
          defaultMessage="Payment Information"
          description="Main heading for the payment step header"
        />
        <SubText>
          <FormattedMessage
            defaultMessage="We do not store your credit card information. All payments are encrypted and securely processed through our PCI compliant provider."
            description="Subtext for the payment step header"
          />
        </SubText>
      </Style>
    </HeaderContainer>
  );
};
